import clientsApi from '@/api/v1/clients';
import hrApi from '@/api/v1/hr';

export default {
  namespaced: true,

  state: {
    isAttachmentProcessing: false,
  },

  mutations: {
    CHANGE_SUBMIT_STATUS(state, status) {
      state.isAttachmentProcessing = status;
    },
  },

  actions: {
    uploadAttachments({ commit, dispatch }, data) {
      commit('CHANGE_SUBMIT_STATUS', true);

      const api = (data.apiType === 'hr') ? hrApi : clientsApi;
      const formData = new FormData();

      formData.append('id', data.id);
      formData.append('record_type', data.recordType);

      for (let i = 0; i < data.attachments.length; i += 1) {
        const file = data.attachments[i];
        formData.append('attachments[]', file);
      }

      return new Promise((resolve, reject) => {
        api.attachments
          .create(formData)
          .then(() => {
            dispatch('showSuccess', ['Updated'], { root: true });
            resolve();
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_SUBMIT_STATUS', false);
          });
      });
    },

    deleteAttachments({ commit, dispatch }, data) {
      commit('CHANGE_SUBMIT_STATUS', true);

      const api = (data.apiType === 'hr') ? hrApi : clientsApi;

      return new Promise((resolve, reject) => {
        api.attachments
          .delete(data.id)
          .then(() => {
            dispatch('showSuccess', ['Deleted'], { root: true });
            resolve();
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_SUBMIT_STATUS', false);
          });
      });
    },

    updateAttachment({ commit, dispatch }, attachmentData) {
      commit('CHANGE_SUBMIT_STATUS', true);

      return new Promise((resolve, reject) => {
        hrApi.attachments
          .update(attachmentData.id, attachmentData.client_visibility)
          .then(() => {
            dispatch('showSuccess', ['Visibility updated'], { root: true });
            resolve();
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_SUBMIT_STATUS', false);
          });
      });
    },
  },
};
